// extracted by mini-css-extract-plugin
export default {"accessOptionGroup":"access-option-group_accessOptionGroup__olD5B"};